(function($){
	
	function onDocumentReady(){
		if($("HTML").hasClass("no-svg")){
			replaceSVGImages();
		}
		
		if($("HTML").hasClass("lt-ie9")){
			redrawIcons();
			fixLastColumnGrid();
			
			// String.trim for <= IE8
			if(typeof String.prototype.trim !== 'function') {
				String.prototype.trim = function() {
					return this.replace(/^\s+|\s+$/g, ''); 
				}
			}
			
		}
		if (isTouchDevice()) {
			//Corrects Firefox on Windows throwing a false positive for touch events
			if (/Firefox/g.test(navigator.userAgent) && /Win32/g.test(navigator.platform)) {
				$('html').removeClass('touch').addClass('no-touch');
			}
		}		
	}
	
	function fixLastColumnGrid() {
		$(".grid").each(function () {
			var last = $(this).children().last();
			last.addClass('last-child');
		});
	}
	
	// IE8 has some trouble with fontcustom icons until the mouse hovers over the element.
	// This clears and redraws them, which seems to fix it.
	function redrawIcons(){
		var head = document.getElementsByTagName('head')[0],
		    style = document.createElement('style');
		style.type = 'text/css';
		style.styleSheet.cssText = ':before,:after{content:none !important';
		head.appendChild(style);
		setTimeout(function(){
		    head.removeChild(style);
		}, 0);
	}

	// In browsers that don't support SVG, any image tag using an 
	// svg will change to the .png file. 
	// Make sure that file is saved in the same folder as the svg!
	function replaceSVGImages(){
		$("img[src$='.svg']").each(function(){
			this.src = this.src.replace(/.svg$/, '.png');
		});
	}

	$(onDocumentReady);
})(jQuery);